export const optInForDS = () => new URLSearchParams(window.location.search.toLowerCase()).get('designsystem') === 'yes'

type DarkOrLightColorScheme = '🌑' | '☀️'
type ColorScheme = DarkOrLightColorScheme | 'auto'

export const isDarkMode = () => document.documentElement.getAttribute('data-theme') === '🌑'

const setDataTheme = (dataTheme: ColorScheme, saveToLocalStorage = true) => {
  if (dataTheme !== 'auto') {
    document.documentElement.setAttribute('data-theme', dataTheme)
  }
  if (saveToLocalStorage) {
    localStorage.setItem('dataTheme', dataTheme)
  }
}

const applyOSPreference = () => {
  const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)').matches
  const dataTheme: DarkOrLightColorScheme = prefersDarkScheme ? '🌑' : '☀️'
  document.documentElement.setAttribute('data-theme', dataTheme)
}

export const initDataTheme = () => {
  const dataThemeFromLocalStorage = localStorage.getItem('dataTheme') as ColorScheme

  if (dataThemeFromLocalStorage === '🌑' || dataThemeFromLocalStorage === '☀️') {
    setDataTheme(dataThemeFromLocalStorage)
  } else {
    applyOSPreference()
    localStorage.setItem('dataTheme', 'auto')
  }
}

export const toggleDarkMode = () => {
  const nextDataTheme = isDarkMode() ? '☀️' : '🌑'
  setDataTheme(nextDataTheme)
  window.location.reload()
}
